import budgetKeys from "../../hooks/api/budget/budgetKeys";

const editBudgetStore = ({ queryClient, id, updatedFields }) => {
  const queryKey = budgetKeys.byId(id);
  const oldData = queryClient.getQueryData(queryKey);

  if (oldData) {
    queryClient.setQueryData(queryKey, { ...oldData, ...updatedFields });
  }
};

export default editBudgetStore;
